import { companyService } from '@/services/api/company.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { companyModel } from '@/models/api/company.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const COMPANY_MODULE = "api/company";

// ACTIONS
export const GET_ALL_COMPANY = 'getAllCompany';
export const CREATE_COMPANY = 'createCompany';
export const GET_COMPANY = 'getCompany';
export const UPDATE_COMPANY = 'updateCompany';
export const UPDATE_COMPANY_STATUS = 'updateCompanyStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_COMPANY_SUCCESS = "allCompanySuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_COMPANY_SUCCESS = "getCompanySuccess";

export const actions = {
    [GET_ALL_COMPANY]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        companyService
            .getAll(filter)
            .then((result) => {
                commit(ALL_COMPANY_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_COMPANY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_COMPANY]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return companyService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_COMPANY_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_COMPANY]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return companyService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_COMPANY_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return companyService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_COMPANY, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_COMPANY_SUCCESS](state, {data}) {
        let company = data.data || [];
        state.list.data = company;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = company.map(item => companyModel(item));
        }
    },
    [GET_COMPANY_SUCCESS](state, data) {
        state.details = companyModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
